import { twdClass } from "../../constants/tailwind.constants";
import { BTN_NORMAL, INPUT_TEXT, INPUT_TEXT_XS } from "../../constants/var.constants";
import { BACK_RIGHT_PANEL_LEVEL, ADD_RIGHT_PANEL_LEVEL } from "../../constants/action.constants";
import FaIcons from "../common/FaIcons";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardSectionPanel } from "./CardSectionPanel";
import { CardLayoutPanel } from "./CardLayoutPanel";
import { CardLinkPanel } from "./CardLinkPanel";


import { TextElementPanel } from "./TextElementPanel";

import { cloneDeep, findIndex, find } from "lodash";
import { CardElementStylesPanel } from "./CardElementStylesPanel";
import { CardLocationStylesPanel } from "./CardLocationStylesPanel";
import { Button, BtnStyle, BtnBack, BtnAdd, BtnNext} from "../ui/com_ui";
import {RenderArea} from "../form/ui-elements/RenderArea";
import { RspHeader } from "./common/RspHeader";
import { RspListComponent } from "./common/RspListComponent";
import { RspMapColumns } from "./common/RspMapColumns"

const MC2 = twdClass(
  "text-sm font-semibold bg-gray-50 p-2 border rounded-md shadow-sm cursor-pointer"
);
const MC3 = twdClass("flex items-center justify-between");



export const ManageTableElementsPanel = ({
  setActiveColId,
  setActiveEleId,
  setActivePanel,
  currentBlock,
  columnNames,
  updateElementValue,
}) => {
  const dispatch = useDispatch();
  const {cardElements=[], cardLocations=[], cardConfig={}, cardLink={}, table={}} = currentBlock 
  const {columns=[]} = table;
  
 
  const [showStylePanel, setStylePanel] = useState(false);
  const [styleId, setStyleId] = useState(false);


  const renderElement = ({item, index, cIndex}) => {
    const updateProp='text'  

    const updateElementValueL = (key, value) => {
      updateElementValue(`table.columns[${cIndex}].elements[${index}][${key}]`, value);
    }

    return (
      <div className={twdClass("")}>        
        <div className={twdClass("flex items-center mb-2 text-xs ")}>
          <div className={twdClass("w-36 mb-1")}>Type:</div>
          <div className={twdClass("w-full")}>
            <select
              className={twdClass(INPUT_TEXT_XS)}
              onChange={(e) => {
                /*addNewSectionData(e)*/
                updateElementValueL(`type`, e.target.value);
              }}
              value={item.type}
            >
              <option value="">Select</option>              
              {/* <option value="video">Video</option> */}
              <option value="text">Text</option>
              <option value="image">Image</option>
              <option value="tags">Tags</option>
              {/*<option value="button">Button</option>
              <option value="link">Link</option> */}             
            </select>
          </div>
        </div>       
        <RspMapColumns {...{
          data:item,
          columnNames,
          updateProp,
          textValue:item.text,
          onUpdate:(pitem, params=[])=>{
            console.log("pitem", pitem, params)
            if(item.type=='image', params.length){
              pitem.imgSrc=params[0].value
            }
            updateElementValue(`table.columns[${cIndex}].elements[${index}]`, pitem);
          }

        }}/>
        {item.type!='image' && <div className={twdClass("flex items-center mb-2 text-xs ")}>
          <div className={twdClass("w-36 mb-1")}>Text:</div>
          <div className={twdClass("w-full")}>
            <input
              type='text'
              className={twdClass(INPUT_TEXT)}
              value={item.text}
              onChange={(e) => {
                //appendPrepand(e.target.value);
                updateElementValueL(`text`, e.target.value);
              }}
            />
          </div>
        </div> }      
        {/*<div>{item.label} {item.id} </div>*/}
      </div>
    )
  }
  const renderColumn = ({item, index}) => {
    const {id, elements=[]} = item
    //console.log(index)
    return (
      <div className={twdClass("")}> 
        <div className={twdClass("flex items-center mb-2 text-xs ")}>
          <div className={twdClass("w-36 mb-1")}>Label:</div>
          <div className={twdClass("w-full")}>
            <input
              type="text"
              className={twdClass(INPUT_TEXT_XS)}
              value={item.label}
              onChange={(e) => {
                //appendPrepand(e.target.value);
                updateElementValue(`table.columns[${index}].label`, e.target.value);
              }}
            />
          </div>
        </div>        
        <RspListComponent {...{
          items:elements,
          title:'Elements',              
          element_label:'Element',
          color:'secondary',
          size:'xs', 
          onItemStyle:(props)=>{
            setStylePanel(true)
            setActiveColId(id)
            setActiveEleId(props.id)
            setActivePanel("tableEleStyle")
          },       
          onAdd:(props)=>{ 
            console.log("onAdd", props.items)
            updateElementValue(`table.columns[${index}].elements`, props.items);
          },
          onDelete:(props)=>{ 
            console.log("onDelete", props.items)
            updateElementValue(`table.columns[${index}].elements`, props.items);
          },
          onShuffle:(props)=>{ 
            console.log("onShuffle", props.items)
            updateElementValue(`table.columns[${index}].elements`, props.items);
          },              
          onUpdate:(props)=>{ 
            console.log("onUpdate", props.items)
            updateElementValue(`table.columns[${index}].elements`, props.items);
          },
          onRenderItem:(props)=>{
            return renderElement({...props, cIndex:index})
          },
        }}/>  
        {/*<div>{item.label} {item.id}</div>  */}
      </div>
    )
  }
  return (
    <>
      
        <RenderArea {...{path:'designtable'}}>   
          <div className={twdClass("px-3")}>
            <RspHeader {...{
              onBack:() => setActivePanel("main"),
              onStyle:() => setActivePanel("tablestyle"),
              title:"Table Design",
            }}/> 
            <RspListComponent {...{
              items:columns,
              title:'Columns',              
              element_label:'Column',
              color:'primary',
              size:'sm',
              onItemStyle:(props)=>{
                setStylePanel(true)
                setActiveColId(props.id)
                setActivePanel("tableColStyle")
              },   
              onAdd:(props)=>{ 
                console.log("onAdd", props.items)
                updateElementValue("table.columns", props.items);
              },
              onDelete:(props)=>{ 
                console.log("onDelete", props.items)
                updateElementValue("table.columns", props.items);
              },
              onShuffle:(props)=>{ 
                console.log("onShuffle", props.items)
                updateElementValue("table.columns", props.items);
              },              
              onUpdate:(props)=>{ 
                console.log("onUpdate", props.items)
                updateElementValue("table.columns", props.items);
              },
              onRenderItem:(props)=>{
                return renderColumn(props)
              },
            }}/> 
          </div>
        </RenderArea>
    </>
  );
};
